import React from 'react'
import { observer } from 'mobx-react'

import BookkeepingManagerDetailsViewModel from './BookkeepingManagerDetailsViewModel'
import DetailsHeader from './DetailsHeader'
import DetailsContent from './DetailsContent'
import ProviderSection from './ProviderSection'
import DetailsFooter from './DetailsFooter'

import styles from './BookkeepingManagerDetails.sass'
import Member from 'iam/models/Member'

interface BookkeepingManagerDetailsProps {
  vm: BookkeepingManagerDetailsViewModel
}

export default observer(function BookkeepingManagerDetails({
  vm,
}: BookkeepingManagerDetailsProps) {
  if (!vm.showing) {
    return null
  }

  return (
    <div className={styles.root} data-test="bookkeeping-manager-details">
      <DetailsHeader onClose={vm.close} />
      <DetailsContent vm={vm} />
      {vm.bookkeepingPendingAction.championPro !== Member.none && (
        <ProviderSection vm={vm.bookkeepingPendingAction} />
      )}
      <DetailsFooter vm={vm} />
    </div>
  )
})
